import { useRecoilState, useResetRecoilState } from 'recoil';
import { getMaintenanceTypes } from '../../../services/maintenanceService';
import { maintenanceTypesFiltersState, maintenanceTypesReloadListState } from '../../../storage/maintenanceTypes';
function useMaintenanceTypes() {
  const [filters, setFilters] = useRecoilState(maintenanceTypesFiltersState);
  const [reload, setReload] = useRecoilState(maintenanceTypesReloadListState);
  const resetAllFilters = useResetRecoilState(maintenanceTypesFiltersState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      ownedByMe: false,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetMaintenanceTypes = async () => {
    const { types, error, total } = await getMaintenanceTypes({
      page: filters.page,
      search: filters.search,
    });
    return {
      types,
      error,
      total,
    };
  };

  return {
    loadFleetMaintenanceTypes,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
  };
}

export default useMaintenanceTypes;
